import { Backdrop, makeStyles, Modal } from '@material-ui/core';
import React from 'react';
import placeHolderProdImage from '../../prod.png';


  
function getModalStyle() {
    return {
        top: `2px`,
        left: `2px`,
        bottom: `2px`,
        right: `2px`,
        inset: '-2px'
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '98%',
        height: '98%',
        border: '0px solid #f7f7f7',
        top: `2px`,
        left: `2px`,
        bottom: `2px`,
        right: `2px`,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100%',
            border: '0',
        },
        margin: 'auto',
        backgroundColor: 'transparent',
        boxShadow: theme.shadows[0],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'zoom-out',
        overflow: 'auto',
        outline: 'none',
    },
    productLargeImage: {
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: 'auto',
            border: '0',
        },
        alignSelf: 'flex-start',
        margin: 'auto',
    }
  }));
const ImageModel = (props) => {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const { open, handleClose, product } = props;
    
    console.log("Product", product);

    return (
        <Modal
            className="modal-image"
            disableAutoFocus
            BackdropProps={{ style: { backgroundColor: "rgba(255, 255, 0, 1)", opacity: 0.69 } }}
            open={open}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description">
            <div style={{...modalStyle}} className={classes.paper} onClick={handleClose}>
                {/* <h2 id="simple-modal-title">Text in a modal</h2>
                <p id="simple-modal-description">
                    Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                </p> */}
                <img src={product.largeImage ? product.largeImage : placeHolderProdImage} className={classes.productLargeImage} />
            </div>
      </Modal>
    );
}

export default ImageModel;